export {
  i18n
} from '../i18n'
